/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo } from "react";
import useGetBrandList from "../../utils/CustomHooks/useBrandList";
import { isValidArray } from "../../utils/Functions/Filter";
import { useNavigate, useSearchParams } from "react-router-dom";
import NewLoader from "../../Components/Loader";
import BrandPage from "./BrandPage";

const ExploreBrandById = () => {
  const { brandList, getBrandList } = useGetBrandList();
  const [query] = useSearchParams();
  const brand_id = query.get("brand_id");
  const navigate = useNavigate();
  useEffect(() => {
    if (brand_id) {
      getBrandList(
        {
          brand_ids: [brand_id],
        },
        () => {},
        () => {
          navigate("/", { replace: true });
        }
      );
    } else {
      navigate("/", { replace: true });
    }
  }, [brand_id]);
  const brand = useMemo(
    () =>
      brand_id &&
      (isValidArray(brandList) ? brandList.find((x) => x.brand_id === brand_id) || {} : {}),
    [brandList, brand_id]
  );
  if (!brand.brand_id) return <NewLoader />;

  return <BrandPage brand={brand} />;
};

export default ExploreBrandById;
